import { useMemo } from 'react'

import { Box, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import { Icon } from '@factorialco/factorial-one-react'
import { AlertCircle, CheckCircle } from '@factorialco/factorial-one-react/icons/app'
import { ShiftManagementRolesRequirementsFragment } from 'generated/resources/graphql'

import type UnassignedShift from 'modules/shift_management/store/internal/models/UnassignedShift'

interface Props {
  unassignedShift: UnassignedShift
  roles: ShiftManagementRolesRequirementsFragment[]
  originalCounter: number
  totalAssignedShifts: number
}

const RolesDetails = ({ unassignedShift, roles, originalCounter, totalAssignedShifts }: Props) => {
  const [isTooltipOpen, setIsTooltipOpen] = useToggle(false)
  const icon = originalCounter > totalAssignedShifts ? AlertCircle : CheckCircle
  const iconColor =
    originalCounter > totalAssignedShifts ? 'text-f1-icon-warning' : 'text-f1-icon-positive'

  const rolesMap = useMemo(() => {
    const map = new Map<string, string>()
    roles.forEach((role) => map.set(String(role.id), role.name))
    return map
  }, [roles])

  const buildLabel = () => {
    return unassignedShift.jobCatalogRolesIds
      .map((id) => rolesMap.get(String(id)))
      .filter(Boolean)
      .join(', ')
  }

  return (
    <Box flexDirection="row" justifyContent="flexStart" alignItems="center" gap="s2">
      <Icon icon={icon} size="sm" className={iconColor} />

      <Text size="100" weight="medium" letterSpacing="s2">
        {totalAssignedShifts}/{originalCounter}
      </Text>
      <Text.Normal ellipsis size="100" weight="medium">
        {rolesMap.get(String(unassignedShift.jobCatalogRolesIds[0]))}
      </Text.Normal>
      {unassignedShift.jobCatalogRolesIds.length > 1 && (
        <Box
          flexDirection="row"
          onMouseEnter={setIsTooltipOpen(true)}
          onMouseLeave={setIsTooltipOpen(false)}
        >
          <Tooltip.Alt open={isTooltipOpen} attachment="bottom center" label={buildLabel()}>
            <Box>
              <Text.Normal size="100" weight="medium">
                (+{unassignedShift.jobCatalogRolesIds.length - 1})
              </Text.Normal>
            </Box>
          </Tooltip.Alt>
        </Box>
      )}
    </Box>
  )
}

export { RolesDetails }
